import forEachSelector from '../elements/forEachSelector';
import addStartupScript from '../events/addStartupScript';
import addTargetEventListener from '../events/addTargetEventListener';
import { selectors } from './elements/constants';
import getFormWizard from './elements/getFormWizard';
import getStep from './elements/getStep';
import { events } from './models/events';
import * as stepModel from './models/step';

/**
 * Returns true if this step counts towards the progress count (because it has visible inputs).
 * @param {Element} step
 * @returns {boolean}
 */
const isCountable = step => (
  stepModel.isCountable(step) && step.matches([selectors.complete, selectors.active].join())
);

/**
 * Gets the first sibling of an element
 * @param {Element} element
 * @returns {Element}
 */
const getFirstSibling = element => element.parentNode.firstElementChild;

/**
 * Calculates the number of completed steps in the form up to and including
 * the current panel.
 * @param {Element} currentPanel - The current panel (included in the count)
 * @returns {integer}
 */
function calculateCompletedSteps(currentPanel) {
  let completed = 0;

  for(var step = getFirstSibling(currentPanel); step; step = step.nextElementSibling) {
    if(isCountable(step) || step === currentPanel) { completed += 1; }
    if(step === currentPanel) { break; }
  }

  return completed;
}

/**
 * Calculates the number of steps in the form within the branch that includes
 * the current panel.
 * @param {Element} currentPanel - The current panel
 * @returns {integer}
 */
function calculateMaxSteps(currentPanel) {
  const form = getFormWizard(currentPanel);
  const steps = Array.from(form.querySelectorAll(selectors.step));
  return stepModel.getMaxSteps(steps);
}

/**
 * Updates the progress bar to show the current step and total steps.
 *
 * @param {CustomEvent} event - An event that updates the progress bar, e.g. wizard.showStep
 * @param {Element} event.target - The panel that raised the event
 */
function updateProgressBar({ target }) {
  const wizard = getFormWizard(target);
  const currentPanel = getStep(target);

  if(!currentPanel || !currentPanel.matches(selectors.panel)) { return; }

  const indicator = wizard.querySelector(selectors.progressBarIndicator);
  const text = wizard.querySelector(selectors.progressBarText);
  const totalSteps = calculateMaxSteps(currentPanel);
  const completedSteps = Math.min(calculateCompletedSteps(currentPanel), totalSteps);

  if(indicator) {
    indicator.style.width = `${(100 * completedSteps) / totalSteps}%`;
  }

  if(text) {
    text.innerHTML = `${completedSteps} of ${totalSteps}`;
  }
}

// Whenever a panel is shown within a formWizard, update the progress bar
addTargetEventListener(events.showStep, selectors.wrapper, updateProgressBar);

// On start up, update the progress bar
// TODO: A startup event raised from clicking get-started should trigger this
addStartupScript(() => {
  const panelsSelector = [selectors.panel, selectors.active].join('');
  forEachSelector(panelsSelector, el => updateProgressBar({ target: el }));
});

